module.exports = __webpack_public_path__ + "img/Bois sculpte anciennes salines de Villeroy Sete-900-600.ca8734da.png";